import { Button, IconButton, TableRowHeader } from '@/common'
import LocalizedNumberFlow from '@/components/LocalizednNumberFlow'
import { TableCell } from '@/common'
import { TableRow } from '@/common'
import { UnitLabel } from '@/shared/config/config'
import { useEffect } from 'react'
import { useState } from 'react'
import useOrganizationDocuments from '@/shared/hooks/useOrganizationDocuments'
import useI18n from '@/shared/hooks/useI18n'
import { scrapMaterialName } from '@/api/PreconsumerScrapMaterialModel'
import { TrashIcon } from '@/common/components/icons'

export default function InputMaterialsTableRow({
  material: { id, quantityInTonnes, proofFilePath, materialName, internalId, details },
  isViewMode,
  onRemove,
  onEdit
}: {
  material: {
    id: string | number
    quantityInTonnes: number
    details: string | null
    proofFilePath: string | null
    materialName: string
    internalId?: string | null
  }
  isViewMode: boolean

  onEdit: (id: string | number, isScrap: boolean) => void
  onRemove: (id: string | number, isScrap: boolean) => void
}) {
  const { t } = useI18n()
  const { generateDownloadUrl } = useOrganizationDocuments()
  const [url, setUrl] = useState<string>('')
  useEffect(() => {
    const fetchUrl = async () => {
      if (proofFilePath) {
        const url = await generateDownloadUrl(proofFilePath)
        if (url) {
          setUrl(url)
        }
      }
    }
    if (!url) {
      fetchUrl()
    }
  }, [generateDownloadUrl, proofFilePath, url])

  return (
    <TableRow>
      <TableRowHeader className="text-left">{materialName}</TableRowHeader>
      <TableCell className="text-sm">{details ?? '-'}</TableCell>
      <TableCell>{!internalId ? '-' : internalId}</TableCell>
      <TableCell className="text-sm">
        {proofFilePath ? (
          <a href={url} download={proofFilePath} className="text-blue-500 hover:underline">
            {proofFilePath}
          </a>
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell>
        <LocalizedNumberFlow value={quantityInTonnes} /> {UnitLabel.t}
      </TableCell>
      {!isViewMode && (
        <TableCell>
          <div className="flex gap-2 justify-end">
            <Button
              sizeType="sm"
              variant="txt-default"
              onClick={() => onEdit(id, materialName === scrapMaterialName)}
            >
              {t('common:actions.edit')}
            </Button>
            <IconButton
              variant="txt-danger"
              icon={<TrashIcon />}
              onClick={() => onRemove(id, materialName === scrapMaterialName)}
            />
          </div>
        </TableCell>
      )}
    </TableRow>
  )
}
